import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";

export interface PeriodSelectorProps {
  id?: string;
  selectedPeriod: string;
  onChange: (period: string) => void;
  maxYears?: number;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onChange,
  maxYears = 5,
  id = "period-selector",
}) => {
  const handlePeriodSelect = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const renderMenuItems = () => {
    const items = [];
    for (let i = 1; i <= maxYears; i++) {
      items.push(
        <MenuItem key={i} value={i}>
          Period: Last {i} {i === 1 ? "year" : "years"}
        </MenuItem>
      );
    }
    return items;
  };

  return (
    <FormControl size="small" sx={{ minWidth: 150, maxWidth: "100%" }}>
      <Select id={id} value={selectedPeriod} onChange={handlePeriodSelect}>
        {renderMenuItems()}
      </Select>
    </FormControl>
  );
};
